import { EquipmentResponse } from '../../../../../store/equipments/equipments.types'
import { TripPayload } from '../../../../../store/trips/trips.types'

export const addTractor = (equipment: EquipmentResponse): TripPayload[] => [
  {
    type: 'HOOK_TRACTOR',
    sequenceId: 0,
    tractorId: equipment?.equipmentId != null ? String(equipment.equipmentId) : null,
    trailerId: null,
    name: equipment?.unitNumber,
    address: equipment?.address,
    startTime: '2025-01-21T04:34:36.237',
    estimatedTime: '2025-01-21T04:34:36.237',
  },
  {
    type: 'DROP_TRACTOR',
    sequenceId: 100,
    tractorId: equipment?.equipmentId != null ? String(equipment.equipmentId) : null,
    trailerId: null,
    name: equipment?.unitNumber,
    address: equipment?.address,
    startTime: '2025-01-21T04:34:36.237',
    estimatedTime: '2025-01-21T04:34:36.237',
  },
]
